export default __webpack_public_path__ + "static/media/landing-block-constructor.7d5c5d71.svg";